export const MAX_NAME_LENGTH = 100

export const MAX_DESCRIPTION_LENGTH = 600

export const MAX_COMMAND_LENGTH = 25
